import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#E31D1C\" fill-rule=\"evenodd\" d=\"M0 0v12h16V0z\" clip-rule=\"evenodd\"></path><mask id=\"a\" width=\"16\" height=\"12\" x=\"0\" y=\"0\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:luminance;\"><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M0 0v12h16V0z\" clip-rule=\"evenodd\"></path></mask><g mask=\"url(#a)\"><path fill=\"#F1F9FF\" fill-rule=\"evenodd\" d=\"M9 3H7v2H5v2h2v2h2V7h2V5H9z\" clip-rule=\"evenodd\"></path></g>", 3)
  ]))]))
}
export default { render: render }